import { render, staticRenderFns } from "./baseList.vue?vue&type=template&id=24288826&scoped=true&"
import script from "./baseList.vue?vue&type=script&lang=js&"
export * from "./baseList.vue?vue&type=script&lang=js&"
import style0 from "./baseList.vue?vue&type=style&index=0&id=24288826&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24288826",
  null
  
)

export default component.exports